export const COLORS = {
  accent: '#8BC63F',
  badge: '#6698c1',
  dark: '#1E242D',
  error: '#FF5252',
  favorite: '#E05358',
  grey: '#9E9E9E',
  info: '#2196F3',
  light: '#EFF0EF',
  primary: '#1C3664',
  secondary: '#2EA4DC',
  success: '#4CAF50',
  warning: '#FB8C00'
}

export function parseColor (color) {
  const VALID_HEX_COLOR = /^#([0-9a-f]{3}){1,2}$/i
  return VALID_HEX_COLOR.test(color)
    ? (color.length === 4 ? `#${[].map.call(color.substring(1), h => h + h).join('')}` : color)
    : COLORS[color] ?? COLORS.success
}

/*
 * To reduce bundle size, the following method
 * was extracted from: https://github.com/Qix-/color/blob/master/index.js#L299-L304
 */
export function isDark (colorValue) {
  const color = colorValue.substring(1, 7)
  const r = parseInt(color.substring(0, 2), 16)
  const g = parseInt(color.substring(2, 4), 16)
  const b = parseInt(color.substring(4, 6), 16)
  return ((r * 299 + g * 587 + b * 114) / 1000) < 128
}
